import React from "react";
import { PrimaryButton, TertiaryButton } from "./Button";

/* small inline icon */
const Bolt = ({ className = "" }) => (
  <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path
      d="M8 13H3L13 1h3l-3 8h6L12 23H9l3-10H8Z"
      stroke="#F4C505"
      strokeWidth="2"
      fill="none"
    />
  </svg>
);

export default function PaymentResultModal({
  open,
  type, // "success" | "failure"
  remainingCredits,
  onClose,
  onRetry,
  onBook,
}) {
  if (!open) return null;

  const isSuccess = type === "success";
  const showCredits = isSuccess && typeof remainingCredits === "number";

  return (
    <div className="fixed inset-0 z-[100] bg-black/40 grid place-items-center px-5">
      <div className="w-full max-w-[400px] bg-white p-6 shadow-xl text-center">
        {/* top divider */}
        <div className="w-14 h-[3px] mx-auto bg-[#E6E6E6] rounded mb-8" />
        <div className="grid place-items-center gap-4">
          {/* Icon */}
          {isSuccess ? (
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
              <rect x="18" y="14" width="28" height="28" stroke="#269347" strokeWidth="3" />
              <path d="M26 29l6 6 10-12" stroke="#269347" strokeWidth="4" fill="none" />
              <rect x="24" y="20" width="28" height="28" stroke="#269347" strokeWidth="3" />
            </svg>
          ) : (
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
              <rect x="18" y="14" width="28" height="28" stroke="#B9452F" strokeWidth="3" />
              <path d="M26 26l14 14M40 26L26 40" stroke="#B9452F" strokeWidth="4" />
              <rect x="24" y="20" width="28" height="28" stroke="#B9452F" strokeWidth="3" />
            </svg>
          )}

          <div
            className={`text-[18px] font-bold ${
              isSuccess ? "text-[#269347]" : "text-[#B9452F]"
            }`}
          >
            {isSuccess ? "+ Credits added" : "Oops! Payment Failed"}
          </div>

          {showCredits ? (
            <div className="w-full border border-[#DEDEDE] px-4 py-3 flex items-center justify-between">
              <span className="text-[#8F9098]">Total Credits</span>
              <span className="flex items-center gap-2">
                <Bolt />
                <span className="font-extrabold">{remainingCredits}</span>
              </span>
            </div>
          ) : null}

          <div className="w-full mt-4">
            {isSuccess ? (
              <PrimaryButton label="BOOK TRAINER" onClick={onBook} className="!w-full" />
            ) : (
              <>
                <PrimaryButton label="RETRY" onClick={onRetry} className="!w-full" />
                <TertiaryButton
                  label="CONTACT SUPPORT"
                  layout="split"
                  onClick={onClose}
                  className="!w-full mt-3"
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
